import { useState } from "react";
import API from "../../api/api";
import "../../style/add-dept.css"; // Reusing form styles for consistency
import { useNavigate } from "react-router-dom";

export default function AddState() {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !code.trim()) return;

    try {
      setLoading(true);

      await API.post("/states", {
        name: name.trim(),
        code: code.trim().toUpperCase(),
        active: true // Active by default
      });

      setName("");
      setCode("");
      alert("State created successfully");
      navigate("/admin/states");
    } catch (err) {
      console.error("Create state error", err);
      alert(err.response?.data?.message || "Failed to create state");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-dept-page">
      <button className="back-button" onClick={() => navigate("/admin/states")}>
        Back
      </button>

      <h1>Add State</h1>

      <form className="admin-dept-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>State Code (2 Characters)</label>
          <input
            type="text"
            placeholder="GJ"
            maxLength={2}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            style={{ textTransform: "uppercase" }}
          />
        </div>

        <div className="form-group">
          <label>State Name</label>
          <input
            type="text"
            placeholder="Gujarat"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Creating..." : "Create State"}
        </button>
      </form>
    </div>
  );
}
